export const autoBindDecorator = <T extends object>(service: T) =>
  new Proxy(service, {
    get(target, prop, receiver) {
      const value = Reflect.get(target, prop, receiver)
      return typeof value === 'function' ? value.bind(target) : value
    }
  })

export const formDataGenerator = (data: object) =>
  Object.entries(data).reduce((d, [key, value]) => `${d ? d + '&' : ''}${key}=${value}`, '')